(function () {
    'use strict';

    function init() {
        const container = document.querySelector('.js-people-carousel');
        if (!container) return;

        const itemsCount = container.style.getPropertyValue('--items-count');

        setupSwiper('.js-people-carousel', {
            containerSelector: '.js-people-carousel-container',
            jsSelector: '.js-people-carousel',
            swiperOptions: {
                slidesPerView: itemsCount > 1 ? 1.1 : 1,
                spaceBetween: 20,
                breakpoints: {
                    580: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1280: { slidesPerView: 4 },
                    1400: { slidesPerView: 5 },
                    1600: { slidesPerView: 6 },
                },
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();